import { jsx } from "react/jsx-runtime";
import { Activity } from "./Activity/index.js";
import { INVALID_PROPS_ERROR, SpinnerSize, COMPONENT_NAME } from "./constants.js";
import { StyledActivityContainer } from "./styles.js";
import { SpinnerInline } from "./view.inline.js";
import { SpinnerOverlay } from "./view.overlay.js";
import { getDataTestId } from "../../Util/index.js";
const Spinner = ({
  size,
  isInline,
  label,
  hasLabel = false,
  hasBackdrop = true,
  showBackground,
  spinnerColor,
  uniqueId
}) => {
  const displayType = "inline";
  if (!label) {
    console.error(INVALID_PROPS_ERROR);
    return null;
  }
  let displaySize = size;
  if (!size) {
    displaySize = isInline ? SpinnerSize.Small : SpinnerSize.Large;
  }
  const activityProps = {
    label,
    size: displaySize,
    hasLabel,
    spinnerColor
  };
  if (isInline === true || displaySize === SpinnerSize.Small) {
    return /* @__PURE__ */ jsx(
      SpinnerInline,
      {
        "data-testid": getDataTestId(
          COMPONENT_NAME,
          displayType,
          uniqueId
        ),
        children: /* @__PURE__ */ jsx(
          Activity,
          {
            ...activityProps,
            size: displaySize || SpinnerSize.Small
          }
        )
      }
    );
  }
  const updatedShowBackground = displaySize === SpinnerSize.Large && (showBackground || hasLabel);
  return /* @__PURE__ */ jsx(
    SpinnerOverlay,
    {
      hasBackdrop,
      "data-testid": getDataTestId(COMPONENT_NAME, "overlay", uniqueId),
      children: /* @__PURE__ */ jsx(StyledActivityContainer, { showBackground: updatedShowBackground, children: /* @__PURE__ */ jsx(Activity, { ...activityProps }) })
    }
  );
};
Spinner.displayName = COMPONENT_NAME;
export {
  Spinner,
  SpinnerSize
};
